import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import {
    TextField,
    Typography,
} from '@material-ui/core';
import { SET_MODAL_WINDOW_DATA } from '../../../../../App/redux/constants/modalWindow.constants';
import { ADD_BIKE_MODEL_NEW_PRICE_SUGGESTION_SAGA } from '../../../redux/constants/bikeModel.constants';

class AddNewPriceSuggestion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            note: '',
        };
    }

    componentDidMount() {
        const { dispatch, modelId } = this.props;

        dispatch({
            type: SET_MODAL_WINDOW_DATA,
            payload: {
                onSave: () => {
                    const { note } = this.state;
                    dispatch({
                        type: ADD_BIKE_MODEL_NEW_PRICE_SUGGESTION_SAGA,
                        newRecord: note,
                        modelId,
                    });
                },
            },
            ignoreValueAsFn: true,
        });
    }

    handleChangeField(key, value) {
        this.setState({ [key]: value });
    }

    render() {
        const { note } = this.state;

        return (
            <Row>
                <Col span={24}>
                    <Typography variant="h6" color="primary" gutterBottom>Add Price Suggestion</Typography>
                </Col>
                <Col span={24}>
                    <div>
                        <TextField
                            label="Enter price suggestion for this model of bike"
                            value={note}
                            onChange={(event) => this.handleChangeField('note', event.target.value)}
                            fullWidth
                            variant="outlined"
                            margin="dense"
                            size="small"
                            type="text"
                        />
                    </div>
                </Col>
            </Row>
        );
    }
}

export default connect()(AddNewPriceSuggestion);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/ModelPriceSuggestions/AddNewPriceSuggestion.js